import React from "react";

// Reusable inner-page hero.
// variant "image" (default): background photo with dark overlay + white text.
// variant "light": clean cream header, no photo, dark text (bright & elegant).
// overlay: tailwind gradient classes to control darkness on image variant.
const PageHero = ({
  image,
  kicker,
  title,
  lead,
  variant = "image",
  overlay = "from-black/55 via-black/40 to-black/70",
}) => {
  if (variant === "light") {
    return (
      <section className="relative w-full overflow-hidden bg-[#faf7f2] pt-32 pb-16 md:pt-40 md:pb-20">
        {/* soft decorative accents */}
        <div className="pointer-events-none absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#e9d9c9]/50 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-32 left-1/3 w-96 h-96 rounded-full bg-[#e6ddcf]/40 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
          {kicker && (
            <span className="text-[#b5533a] text-xs uppercase tracking-[0.28em] mb-4 block">
              {kicker}
            </span>
          )}
          <h1 className="font-serif text-[#1c1b1a] text-5xl md:text-7xl leading-[1.02]">
            {title}
          </h1>
          {lead && (
            <p className="mt-6 max-w-2xl text-[#5a554c] text-base md:text-lg leading-relaxed">
              {lead}
            </p>
          )}
          <div className="mt-8 h-[3px] w-24 bg-[#b5533a]" />
        </div>
      </section>
    );
  }

  return (
    <section className="relative h-[52vh] min-h-[380px] w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: `url(${image})` }}
      />
      <div className={`absolute inset-0 bg-gradient-to-b ${overlay}`} />
      <div className="relative h-full mx-auto max-w-7xl px-5 lg:px-8 flex flex-col justify-end pb-14">
        {kicker && (
          <span className="text-[#f0c3ab] text-xs uppercase tracking-[0.28em] mb-4">
            {kicker}
          </span>
        )}
        <h1 className="font-serif text-white text-4xl md:text-6xl leading-[1.05]">
          {title}
        </h1>
        {lead && (
          <p className="mt-5 max-w-2xl text-white/85 text-base md:text-lg leading-relaxed">
            {lead}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageHero;
